import React from "react";
import { ShieldCheck, Lock, Award } from "lucide-react";

export default function PartnerBar() {
  return (
    <section className="relative bg-white py-10 md:py-12 border-y border-line">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="text-center mb-7">
          <div className="font-mono text-[10.5px] uppercase tracking-[0.22em] font-bold text-navy/45">UK Registered · Secure · Trusted</div>
        </div>
        <div className="bg-sage/50 rounded-2xl px-6 md:px-10 py-6 md:py-7">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 items-center">
            <Badge icon={<ShieldCheck className="h-5 w-5" strokeWidth={2.2} />} label="UK Registered" sub="Co. No. 17214446" />
            <Badge icon={<Lock className="h-5 w-5" strokeWidth={2.2} />} label="SSL Encrypted" sub="AES-256 secure" />
            <Badge icon={<Award className="h-5 w-5" strokeWidth={2.2} />} label="ICO Registered" sub="GDPR compliant" />
            <Badge icon={<ShieldCheck className="h-5 w-5" strokeWidth={2.2} />} label="4.8 on Trustpilot" sub="Rated by UK businesses" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Badge({ icon, label, sub }) {
  return (
    <div className="flex items-center gap-3">
      <div className="h-11 w-11 rounded-xl bg-white border border-line flex items-center justify-center text-emerald-2 shrink-0">
        {icon}
      </div>
      <div>
        <div className="font-display font-extrabold text-[14.5px] text-navy tracking-[-0.02em] leading-tight">{label}</div>
        <div className="text-[11px] text-navy/55 font-semibold mt-0.5">{sub}</div>
      </div>
    </div>
  );
}
